import { Injectable, Inject } from '@angular/core';
import { HttpModule, Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';

@Injectable()

export class AcademicInfoService {

  private _token: string = localStorage.getItem('token');
  marvelBase = 'http://gateway.marvel.com:80/v1/public/';
  marvelPublicKey = 'b9ced31de3874eb2c065a5bce26f8c59';

  constructor(
    private http: Http,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  postAcademicInfo$(info: any): Observable<any> {
    const token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'academicinfo/add-academic-information', info, {
        headers: headers
      })
      .catch(this.handleErrorObservable);
  }

  getAcademicInfo(info: any): Observable<any> {

    const headers = new Headers({ 'Authorization': this._token });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.config.apiEndpoint + 'academicinfo/get-academic-information', info, options)
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
    .catch(this.handleErrorObservable); // ...errors if any

  }

  highSchoolsList() {
    const token = this._token;
    const headers = new Headers({ 'Authorization': token });
    const options = new RequestOptions({ headers: headers });

    return this.http.get(this.config.apiEndpoint + 'academicinfo/get-high-school', options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }

  highSchoolsListByname = (startsWith: string): Observable<any[]> => {
    const token = this._token;
    const headers = new Headers({ 'Authorization': token });
    const options = new RequestOptions({ headers: headers });
    /* return this.http.get(this.config.apiEndpoint + 'academicinfo/get-high-schoolby-name/'+startsWith)
    .map(h => h.json()) */
    return this.http.get(this.config.apiEndpoint + 'academicinfo/get-high-schoolby-name/' + startsWith, options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }

  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    return Observable.throw( error.json().error || 'Server Error' );
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/academic-info.service.ts